module.exports = __webpack_public_path__ + "static/media/photo-1494887205043-c5f291293cf6.9d7c0439.jpg";